// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2DRAP","content":"RecentSearches_content__3pnmh"};